import { render, staticRenderFns } from "./SetupVodacomNewDevice.vue?vue&type=template&id=5b924c2c"
import script from "./SetupVodacomNewDevice.vue?vue&type=script&lang=js"
export * from "./SetupVodacomNewDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports